export enum BulkOperationItemStatusEnum {
    pending,
    success,
    failed,
    skipped
}
